import React from "react";

export default ({ width }) => (
  <div className="graph-container">
    <div className="gridlines"></div>
    <div className="midline"></div>
    <div className="graph-bar animated bounceIn" style={{ width: width + "%" }}></div>
    <div className="graph-labels">
      <div className="graph-mark">$0</div>
      <div className="graph-mark mark-1000">$1000</div>
      <div className="graph-mark mark-3000">$3000</div>
      <div className="graph-mark mark-5000">$5000</div>
    </div>
  </div>

)


// WEBPACK FOOTER //
// ./src/components/css-savings-graph/index.js